import React, { useEffect, useState } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CustomizedSwitches from "./component/CustomizedSwitches";
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import HistoryIcon from '@material-ui/icons/History';
import TextField from '@material-ui/core/TextField';
import { toast } from 'react-toastify';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import { vietcomBankService } from './services/vietcomBankService';

const DEFAULT_PASSWORD = "*******";
const NEW_CONFIRM_TITLE = "TẠO TÀI KHOẢN";
const OLD_CONFIRM_TITLE = "CẬP NHẬT";


function createData( id, accountNumber, isEnable, lastUpdate, password, username, bankName, minLevel, maxLevel, ownerName, status ) {
  console.log("createData: ", id, accountNumber, isEnable, lastUpdate, password, username, bankName, minLevel, maxLevel, ownerName, status);
  if (!lastUpdate) lastUpdate = new Date().getTime();
  const date = new Date(lastUpdate);
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Ho_Chi_Minh',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
  lastUpdate = formatter.format(date);
  password = DEFAULT_PASSWORD;
  if (!minLevel) minLevel = 0;
  if (!maxLevel) maxLevel = 0;
  if (!status) status = 'UNKNOWN';
  return { id, accountNumber, isEnable, lastUpdate, password, username, bankName, minLevel, maxLevel, ownerName, status };
}

// const data = [
//   createData('4738577978097664', 123123123, false, 1710228704608, "123123123", "0858590159", "VCB_PROP", 10, "linh"),
//   createData('4', 456456, true, 1710228704608, "123123", "0858590159", "VCB_PRO", 12)
// ];



const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 1280,
    margin: '0 auto',
    paddingTop: 96,
    paddingBottom: 32,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  paper: {
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.08)',
  },
  tableWrapper: {
    maxHeight: '72vh',
  },
  table: { minWidth: 920 },
  headRow: {
    background: 'linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)',
  },
  headCell: {
    color: '#fff',
    fontWeight: 600,
    fontSize: '0.78rem',
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    whiteSpace: 'nowrap',
    borderBottom: 'none',
    // stickyHeader ép nền ô header thành trắng -> set màu đặc để giữ header xanh
    backgroundColor: '#1666c1',
    '& .MuiTableSortLabel-root': { color: '#fff' },
    '& .MuiTableSortLabel-root:hover': { color: '#bbdefb' },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': { color: '#fff' },
    '& .MuiTableSortLabel-icon': { color: '#fff !important' },
  },
  bodyRow: {
    '&:nth-of-type(even)': { backgroundColor: '#fafafa' },
    '&:hover': { backgroundColor: '#e3f2fd !important' },
    transition: 'background-color 0.15s ease',
  },
  accountCell: {
    fontWeight: 600,
    fontFamily: '"Roboto Mono", monospace',
  },
  bankChip: {
    fontWeight: 600,
    color: '#fff',
  },
  vcbChip: { backgroundColor: '#2e7d32' },
  vtbChip: { backgroundColor: '#c62828' },
  levelChip: {
    fontWeight: 600,
    backgroundColor: '#eceff1',
    color: '#37474f',
  },
  editBtn: {
    color: '#1976d2',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.18)' },
  },
  historyBtn: {
    color: '#2e7d32',
    backgroundColor: 'rgba(46, 125, 50, 0.08)',
    '&:hover': { backgroundColor: 'rgba(46, 125, 50, 0.18)' },
  },
  dialogTitle: {
    background: 'linear-gradient(90deg, #1565c0 0%, #1e88e5 100%)',
    color: '#fff',
  },
  txHeadCell: {
    fontWeight: 600,
    backgroundColor: '#1565c0',
    color: '#fff',
  },
  txRow: {
    '&:nth-of-type(even)': { backgroundColor: '#fafafa' },
  },
  amountUp: { color: '#2e7d32', fontWeight: 600, whiteSpace: 'nowrap' },
  amountDown: { color: '#c62828', fontWeight: 600, whiteSpace: 'nowrap' },
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14,
    border: '1px solid #dadde9',
    '& p': {
      margin: '4px 0',
    },
    '& p:first-child': {
      fontWeight: 'bold',
      marginBottom: 8,
    }
  },
}));

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  if (!Array.isArray(array)) {
    console.error("stableSort expects an array but got:", array);
    return [];
  }

  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const headCells = [
  { id: 'accountNumber', align: 'left', sortable: true, label: 'Số tài khoản' },
  { id: 'minLevel', align: 'center', sortable: true, label: 'Min Level' },
  { id: 'maxLevel', align: 'center', sortable: true, label: 'Max Level' },
  { id: 'username', align: 'left', sortable: true, label: 'Tên đăng nhập' },
  { id: 'ownerName', align: 'left', sortable: true, label: 'Tên chủ tài khoản' },
  { id: 'password', align: 'left', sortable: false, label: 'Mật khẩu' },
  { id: 'bankName', align: 'center', sortable: true, label: 'Ngân hàng' },
  { id: 'isEnable', align: 'center', sortable: true, label: 'Trạng thái' },
  { id: 'lastUpdate', align: 'center', sortable: true, label: 'Ngày cập nhật' },
  { id: 'action', align: 'center', sortable: false, label: 'Hành động' },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classes.headRow}>
        <TableCell padding="checkbox" className={classes.headCell} />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align}
            className={classes.headCell}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.sortable ? (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: '1px solid #eceff1',
  },
  highlight: {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.85),
  },
  titleWrap: {
    flex: '1 1 100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  titleIcon: {
    color: theme.palette.primary.main,
    fontSize: 34,
  },
  title: {
    fontWeight: 700,
    lineHeight: 1.1,
  },
  subtitle: {
    color: theme.palette.text.secondary,
  },
  addButton: {
    color: theme.palette.primary.main,
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected, totalAccounts, handleClickOpenDialog, onRemoveAccounts } = props;

  return (
    <Toolbar className={`${classes.root} ${numSelected > 0 ? classes.highlight : ''}`}>
      {numSelected > 0 ? (
        <Typography className={classes.titleWrap} variant="subtitle1" component="div">
          Đã chọn {numSelected} tài khoản
        </Typography>
      ) : (
        <div className={classes.titleWrap}>
          <AccountBalanceIcon className={classes.titleIcon} />
          <div>
            <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
              Quản lý tài khoản ngân hàng
            </Typography>
            <Typography className={classes.subtitle} variant="caption" component="div">
              {totalAccounts} tài khoản đang cấu hình
            </Typography>
          </div>
        </div>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Xoá tài khoản đã chọn">
          <IconButton
            aria-label="delete"
            color="secondary"
            onClick={onRemoveAccounts}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Thêm tài khoản">
          <IconButton
            aria-label="add account"
            className={classes.addButton}
            onClick={(e) => handleClickOpenDialog(-1)}
          >
            <AddCircleIcon fontSize="large"/>
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};


function ManageVietcomBank() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [buttonName, setButtonName] = useState("TẠO TÀI KHOẢN");
  const [loading, setLoading] = useState({
    fetch: false,
    save: false,
    delete: false,
    history: false
  });
  const [newAccount, setNewAccount] = useState({
    id: null,
    accountNumber: "",
    minLevel: 0,
    maxLevel: 0,
    username: '',
    ownerName: '',
    password: '',
    bankName: 'VietcomBank',
    isEnable: false,
    lastUpdate: new Date().getTime(),
  });

  function resetNewAccount() {
    setNewAccount({
      accountNumber: "",
      minLevel: 0,
      maxLevel: 0,
      username: '',
      ownerName: '',
      password: '',
      bankName: 'VietcomBank',
      isEnable: false,
    })
  }

  
  const handleClickOpenDialog = (index) => {
    if (index !== -1) {
      const oldRow = rows[index];
      console.log("Step1 : ", oldRow.id)
      setNewAccount({
        id: oldRow.id,
        accountNumber: oldRow.accountNumber,
        minLevel: oldRow.minLevel,
        maxLevel: oldRow.maxLevel,
        username: oldRow.username,
        ownerName: oldRow.ownerName,
        password: oldRow.password,
        bankName: oldRow.bankName || 'VietcomBank',
        isEnable: oldRow.isEnable,
        lastUpdate: oldRow.lastUpdate
      })
      setButtonName(OLD_CONFIRM_TITLE);
    } else {
      setButtonName(NEW_CONFIRM_TITLE);
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    resetNewAccount();
  }

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleChange = async (event, rowIndex) => {
    const nextStatus = event.target.checked;
    const row = rows[rowIndex];
    if (!row) return;

    // Optimistic update for faster UX
    setRows(prevRows => {
      const newRows = [...prevRows];
      newRows[rowIndex].isEnable = nextStatus;
      return newRows;
    });

    try {
      const response = await vietcomBankService.updateAccountStatus(row.id, nextStatus);
      if (response?.status !== "OK") {
        throw new Error(response?.message || "Cập nhật trạng thái thất bại");
      }
      toast.success(response.message || "Cập nhật trạng thái thành công");
    } catch (error) {
      // Rollback if API fails
      setRows(prevRows => {
        const newRows = [...prevRows];
        newRows[rowIndex].isEnable = !nextStatus;
        return newRows;
      });
      toast.error(error.message || "Đã xảy ra lỗi khi cập nhật trạng thái");
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    
    // if (name === "accountNumber") {
    //   value = value === '' ? 0 : Number(value);
    //   if (isNaN(value)) value = 0;
    // } else 
    if (name === "minLevel" || name === "maxLevel") {
      value = value === '' ? 0 : Number(value);
    } else if (name === "isEnable") {
      value = e.target.checked;
    }
    
    setNewAccount({ ...newAccount, [name]: value });
  };

  const handleAddAccount = () => {
    if (newAccount.password === DEFAULT_PASSWORD) newAccount.password = '';

    if (newAccount.lastUpdate) newAccount.lastUpdate = null;

    if (buttonName === NEW_CONFIRM_TITLE &&
      (!newAccount.accountNumber || !newAccount.username || !newAccount.password || !newAccount.ownerName || !newAccount.bankName)) {
        return toast.warning("Bạn cần điền đầy đủ thông tin khi tạo");
    }

    if (buttonName === OLD_CONFIRM_TITLE && 
      (!newAccount.accountNumber || !newAccount.username || !newAccount.bankName)) {
      return toast.warning("Bạn cần điền đầy đủ thông tin");
    }

    const accountToSave = {
      ...newAccount,
      // accountNumber: Number(newAccount.accountNumber),
      minLevel: Number(newAccount.minLevel),
      maxLevel: Number(newAccount.maxLevel),
    };
    
    setOpenDialog(false);
    createAccount(accountToSave);
  };

  const handleRemoveAccounts = async () => {
    if (!selected.length) return;
    setOpenConfirmDialog(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(prev => ({ ...prev, delete: true }));
    console.log(JSON.stringify(selected))
    try {
      const response = await vietcomBankService.deleteAccounts(selected);
      if (response.status === "OK") {
        // setRows(prevRows => prevRows.filter(acc => !selected.includes(acc.id)));
        // setSelected([]);
        await getAccount();
        toast.success(response.message || "Xoá tài khoản thành công");
      } else {
        toast.warning(response.message || "Không thể xoá tài khoản");
      }
    } catch (error) {
      toast.error(error.message || "Đã xảy ra lỗi khi xoá tài khoản");
    } finally {
      setLoading(prev => ({ ...prev, delete: false }));
      setOpenConfirmDialog(false);
      setSelected([]);
    }
  };

  const handleViewHistory = async (row) => {
    setSelectedAccount(row);
    setLoading(prev => ({ ...prev, history: true }));
    try {
      const response = await vietcomBankService.getTransactions(row.id);
      // API mới (/mc-user/web/bank/get-transaction) trả về format thống nhất:
      // { status: "OK", data: { transactions: [{ transactionId, amount, message, tranDate }] } }
      // amount đã có dấu (+/-); tranDate dạng "yyyy-MM-dd HH:mm:ss".
      const txs = response?.data?.transactions;
      let normalizedTransactions = [];

      if (response?.status === "OK" && Array.isArray(txs)) {
        normalizedTransactions = txs.map((tx) => {
          const rawTranDate = tx?.tranDate || "";
          const [date = "", time = ""] = rawTranDate.split(" ");
          const amount = tx?.amount || "";
          const cd = amount.startsWith("-") ? "-" : "+";
          return {
            date,
            time,
            message: tx?.message || "",
            amount,
            cd,
            transactionId: tx?.transactionId || ""
          };
        });
      }

      if (normalizedTransactions.length > 0) {
        setTransactions(normalizedTransactions);
        setOpenHistoryModal(true);
      } else {
        toast.warning(response.message || "Không thể tải lịch sử giao dịch.");
        setTransactions([]);
      }
    } catch (error) {
      toast.error(error.message || "Đã xảy ra lỗi khi tải lịch sử giao dịch.");
      setTransactions([]);
    } finally {
      setLoading(prev => ({ ...prev, history: false }));
    }
  };

  const handleCloseHistoryModal = () => {
    setOpenHistoryModal(false);
    setTransactions([]);
    setSelectedAccount(null);
  };

  useEffect(() => {
    // setRows(data);
    getAccount();
  }, [])

  const getAccount = async () => {
    setLoading(prev => ({ ...prev, fetch: true }));
    try {
      const response = await vietcomBankService.getAccounts();
      let accounts = response?.data ?? [];
      if (response.status === "OK" && Array.isArray(accounts)) {
        accounts = accounts.map((e) => 
          createData(e.id, e.accountNumber, e.isEnable, e.lastUpdate, e.password, e.username, e.bankName, e.minLevel, e.maxLevel, e.ownerName, e.status)
        );
        console.log("accounts: ", accounts);
        setRows(accounts);
        console.log("rows: ", rows);
        toast.success(response.message || "Tải danh sách tài khoản thành công");
      } else {
        toast.warning(response.message);
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while fetching accounts");
    } finally {
      setLoading(prev => ({ ...prev, fetch: false }));
    }
  };

  const createAccount = async (account) => {
    setLoading(prev => ({ ...prev, save: true }));
    try {
      const response = await vietcomBankService.createOrUpdateAccount(account);
      if (response.status === "OK") {
        await getAccount();
        // setRows((prevRows) => {
        //   const index = prevRows.findIndex((acc) => acc.id === account.id);
        //   if (index !== -1) {
        //     return prevRows.map((acc) => (acc.id === account.id 
        //       ? createData(account.id, account.accountNumber, account.isEnable, account.lastUpdate, account.password, account.username, account.propType) 
        //       : acc));
        //   } else {
        //     return [...prevRows, createData(account.id, account.accountNumber, account.isEnable, account.lastUpdate, account.password, account.username, account.propType)];
        //   }
        // });
        // toast.success(response.message);
      } else {
        toast.warning(response.message || "Failed to create/update account");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while saving the account");
    } finally {
      setLoading(prev => ({ ...prev, save: false }));
    }
    resetNewAccount();
  };

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <EnhancedTableToolbar
          numSelected={selected.length}
          totalAccounts={rows.length}
          handleClickOpenDialog={handleClickOpenDialog}
          onRemoveAccounts={handleRemoveAccounts}
        />
        <TableContainer className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={'medium'}
            stickyHeader
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            /> 
            <TableBody>
              {
              stableSort(rows, getComparator(order, orderBy))
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.id}
                      selected={isItemSelected}
                      className={classes.bodyRow}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          onChange={(event) => handleClick(event, row.id)}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell component="th" id={labelId} scope="row" align="left" className={classes.accountCell}>{row.accountNumber}</TableCell>
                      <TableCell align="center">
                        <Chip size="small" label={row.minLevel} className={classes.levelChip} />
                      </TableCell>
                      <TableCell align="center">
                        <Chip size="small" label={row.maxLevel} className={classes.levelChip} />
                      </TableCell>
                      <TableCell align="left">{row.username}</TableCell>
                      <TableCell align="left">{row.ownerName}</TableCell>
                      <TableCell align="left">{row.password}</TableCell>
                      <TableCell align="center">
                        <Chip
                          size="small"
                          label={row.bankName}
                          className={`${classes.bankChip} ${row.bankName === 'VietinBank' ? classes.vtbChip : classes.vcbChip}`}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <CustomizedSwitches
                          state={row.isEnable}
                          handleChange={(e) => handleChange(e, index)}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ whiteSpace: 'nowrap' }}>{row.lastUpdate}</TableCell>
                      <TableCell align="center">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                          <Tooltip title="Sửa tài khoản">
                            <IconButton
                              size="small"
                              aria-label="edit"
                              className={classes.editBtn}
                              onClick={() => handleClickOpenDialog(index)}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Lịch sử giao dịch">
                            <span>
                              <IconButton
                                size="small"
                                aria-label="transaction-history"
                                className={classes.historyBtn}
                                onClick={() => handleViewHistory(row)}
                                disabled={loading.history && selectedAccount?.id === row.id}
                              >
                                <HistoryIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {!loading.fetch && rows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={11} align="center" style={{ padding: 48, color: '#90a4ae' }}>
                    <AccountBalanceIcon style={{ fontSize: 48, opacity: 0.4 }} />
                    <Typography variant="body1" style={{ marginTop: 8 }}>
                      Chưa có tài khoản ngân hàng nào
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
        <DialogTitle className={classes.dialogTitle} disableTypography>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            {buttonName === OLD_CONFIRM_TITLE ? 'Cập nhật tài khoản' : 'Thêm tài khoản'}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 16 }}>
          <DialogContentText>
            Điền thông tin cần thiết để thêm mới tài khoản
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Số tài khoản"
            name="accountNumber"
            type="number"
            placeholder="Nhập số tài khoản bằng số"
            fullWidth
            defaultValue={newAccount.accountNumber}
            onChange={handleInputChange}
          />
          <Tooltip 
            title={
              <div>
                <p>Hướng dẫn set level tài khoản:</p>
                <p>- Set level tối thiếu để hiện, ví dụ: có level 2 và 10, thì user level dưới 2 sẽ không hiện tài khoản ngân hàng</p>
                <p>User có level từ 2 đến 9 sẽ được hiện tài khoản level 2 </p>
                <p>User có level lớn hơn hoặc bằng 10 sẽ được hiện tài khoản ngân hàng level 10</p>
              </div>
            }
            placement="right"
            arrow
            classes={{ tooltip: classes.tooltip }}
          >
          <div>
            <TextField
              autoFocus
              margin="dense"
              label="Min Level"
              name="minLevel"
              type="number"
              placeholder="Nhập level tối thiểu để thấy được tài khoản"
              fullWidth
              value={newAccount.minLevel}
              onChange={handleInputChange}
            />
            <TextField
              margin="dense"
              label="Max Level"
              name="maxLevel"
              type="number"
              placeholder="Nhập level tối đa để thấy được tài khoản"
              fullWidth
              value={newAccount.maxLevel}
              onChange={handleInputChange}
            />
          </div>
          </Tooltip>
          <TextField
            margin="dense"
            label="Tên đăng nhập"
            name="username"
            fullWidth
            value={newAccount.username}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            label="Tên chủ tài khoản"
            name="ownerName"
            fullWidth
            value={newAccount.ownerName}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            label="Mật khẩu"
            name="password"
            fullWidth
            value={newAccount.password}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            label="Ngân hàng"
            name="bankName"
            fullWidth
            value={newAccount.bankName}
            onChange={handleInputChange}
            select
            SelectProps={{ native: true }}
          >
            <option value="VietcomBank">VietcomBank</option>
            <option value="VietinBank">VietinBank</option>
          </TextField>
          <CustomizedSwitches state={newAccount.isEnable} handleChange={handleInputChange}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" disabled={loading.save || loading.delete}>
            Huỷ
          </Button>
          <Button 
            onClick={handleAddAccount} 
            color="primary"
            disabled={loading.save}
          >
            {loading.save ? 'Đang lưu...' : buttonName}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirmation Dialog for deletion */}
      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận xoá tài khoản"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selected.length > 1 
              ? `Bạn có chắc chắn muốn xoá ${selected.length} tài khoản đã chọn không?`
              : "Bạn có chắc chắn muốn xoá tài khoản này không?"
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={() => setOpenConfirmDialog(false)} 
            color="primary"
            disabled={loading.delete}
          >
            Huỷ
          </Button>
          <Button 
            onClick={handleConfirmDelete} 
            color="secondary" 
            autoFocus
            disabled={loading.delete}
          >
            {loading.delete ? "Đang xoá..." : "Xoá"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Transaction History Modal */}
      <Dialog
        open={openHistoryModal}
        onClose={handleCloseHistoryModal}
        fullWidth
        maxWidth="md"
        aria-labelledby="history-dialog-title"
      >
        <DialogTitle id="history-dialog-title" className={classes.dialogTitle} disableTypography>
          <Typography variant="h6" style={{ fontWeight: 700 }}>
            Lịch sử giao dịch
          </Typography>
          {selectedAccount && (
            <Typography variant="caption">
              {selectedAccount.bankName} · {selectedAccount.accountNumber}
            </Typography>
          )}
        </DialogTitle>
        <DialogContent style={{ padding: 0 }}>
          <TableContainer style={{ maxHeight: '60vh' }}>
            <Table stickyHeader size="small" aria-label="transaction history table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.txHeadCell}>Ngày</TableCell>
                  <TableCell className={classes.txHeadCell}>Thời gian</TableCell>
                  <TableCell className={classes.txHeadCell}>Nội dung</TableCell>
                  <TableCell className={classes.txHeadCell} align="right">Số tiền</TableCell>
                  <TableCell className={classes.txHeadCell} align="center">Tăng/Giảm</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading.history ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center" style={{ padding: 32 }}>
                      Đang tải...
                    </TableCell>
                  </TableRow>
                ) : transactions.length > 0 ? (
                  transactions.map((tx, index) => {
                    const isDown = (tx.cd || '').includes('-') || (tx.amount || '').startsWith('-');
                    return (
                      <TableRow key={index} className={classes.txRow}>
                        <TableCell style={{ whiteSpace: 'nowrap' }}>{tx.date || tx.tranDate || ''}</TableCell>
                        <TableCell style={{ whiteSpace: 'nowrap' }}>{tx.time}</TableCell>
                        <TableCell>{tx.message}</TableCell>
                        <TableCell align="right" className={isDown ? classes.amountDown : classes.amountUp}>{tx.amount}</TableCell>
                        <TableCell align="center">
                          <Chip
                            size="small"
                            label={isDown ? 'Giảm' : 'Tăng'}
                            style={{
                              backgroundColor: isDown ? '#ffebee' : '#e8f5e9',
                              color: isDown ? '#c62828' : '#2e7d32',
                              fontWeight: 600,
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} align="center" style={{ padding: 32, color: '#90a4ae' }}>
                      Không có giao dịch nào.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistoryModal} color="primary" variant="contained" disableElevation>
            Đóng
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


export default ManageVietcomBank;
